import React from 'react';
import cx from './cx';

const AppCard = ({
  title,
  subtitle,
  actions,
  footer,
  children,
  className = '',
  headerClassName = '',
  bodyClassName = '',
  footerClassName = '',
}) => {
  const hasHeader = title || subtitle || actions;

  return (
    <div className={cx('card', className)}>
      {hasHeader ? (
        <div className={cx('card-header', headerClassName)}>
          {actions ? (
            <div className="d-flex justify-content-between align-items-start gap-2">
              <div>
                {title ? <div className="fw-semibold">{title}</div> : null}
                {subtitle ? <div className="admin-form-card__subtitle">{subtitle}</div> : null}
              </div>
              <div>{actions}</div>
            </div>
          ) : (
            <>
              {title ? <div className="fw-semibold">{title}</div> : null}
              {subtitle ? <div className="admin-form-card__subtitle">{subtitle}</div> : null}
            </>
          )}
        </div>
      ) : null}
      <div className={cx('card-body', bodyClassName)}>{children}</div>
      {footer != null ? <div className={cx('card-footer', footerClassName)}>{footer}</div> : null}
    </div>
  );
};

export default AppCard;
